module.exports = __webpack_public_path__ + "static/media/sort-increase.7876bb17.svg";